export class NotificationBoard {
  constructor() {}

  movingOutPremises: number = 0;
  movingOutTenants: number = 0;
  draftLeaseAgreementsDwelling: number = 0;
  draftLeaseAgreementsCooperativeHousing: number = 0;
  draftLeaseAgreementsOther: number = 0;
  draftLeaseAgreementsParking: number = 0;
  draftLeaseAgreementsPremises: number = 0;
  fixedTermExpirationLeaseAgreementsBlock: number = 0;
  fixedTermExpirationLeaseAgreementsDwelling: number = 0;
  fixedTermExpirationLeaseAgreementsOther: number = 0;
  fixedTermExpirationLeaseAgreementsParking: number = 0;
  fixedTermExpirationLeaseAgreementsPremises: number = 0;
  newFaultNotifications: number = 0;
  overdueInvoices: number = 0;
  nonDeliverableEmailInvoices: number = 0;
  notAttestedInvoices: number = 0;
  incorrectPayments: number = 0;
  banktransactionImportsUnManaged: number = 0;
  securityOfTenureExpirationLeaseAgreementsDwelling: number = 0;
  securityOfTenureExpirationLeaseAgreementsOther: number = 0;
  securityOfTenureExpirationLeaseAgreementsParking: number = 0;
  securityOfTenureExpirationLeaseAgreementsPremises: number = 0;
  terminationMonitoringLeaseAgreementsDwelling: number = 0;
  terminationMonitoringLeaseAgreementsOther: number = 0;
  terminationMonitoringLeaseAgreementsPremises: number = 0;
  terminationMonitoringLeaseAgreementsParking: number = 0;
}
